import React from 'react';
import ContactUs from 'templates/contactUs';

const App = () => (
  <ContactUs />
);

export default App;
